import { useContext } from 'react';

import { PlaybackContext } from '../lib/playbackContext';
import { EnhancedPlayback } from '../lib/enhancedPlayback';

export const usePlayback = (): EnhancedPlayback => {
    const playback = useContext(PlaybackContext);

    if (!playback) {
        throw new Error('Playback not found');
    }

    return playback;
};
